module.exports = __webpack_public_path__ + "img/bg-head.55b3ed70.png";